import React from "react";

export default function NoLocationIcon(props: any) {
  return (
    <svg
      width={40}
      height={40}
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M6.66992 6.66455L33.3366 33.3312"
        stroke="#FF752C"
        strokeWidth={0.666152}
        strokeLinecap="round"
      />
      <path
        d="M10.0415 10.0334C7.97247 12.5192 6.90711 15.6886 7.0545 18.9195C7.20189 22.1504 8.5514 25.2096 10.8382 27.4967L20.0049 36.6634L28.3382 28.33M15.5782 6.1417C17.8969 5.2993 20.4078 5.13583 22.8161 5.67049C25.2245 6.20515 27.4303 7.41574 29.1747 9.16016C30.9192 10.9046 32.1297 13.1104 32.6644 15.5188C33.1991 17.9271 33.0356 20.438 32.1932 22.7567"
        stroke="#FF752C"
        strokeWidth={0.666152}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
